import { getUlxVisitorId } from './CookieUtil';
import { normalizeException } from './normalizeException';

const logPath = '/list/log';

export default function log(tags, event, data) {
    try {
        if (typeof window === 'object') {
            const fixedData = {
                visitorId: getUlxVisitorId()
            };
            // Error properties are non-enumerable, so spreading a raw Error
            // yields {} and every stack we log is lost. Normalize first.
            const normalized = normalizeException(data);
            const details = normalized && typeof normalized === 'object' && !Array.isArray(normalized)
                ? normalized
                : { detail: normalized };
            const xhr = new XMLHttpRequest();
            const payload = {
                tags,
                event,
                data: { ...fixedData, ...details }
            };
            xhr.open('POST', logPath);
            xhr.send(JSON.stringify(payload));
        }
    } catch (e) {
        // This is a fire and forget method, so just silently fail. Note this
        // must never throw: callers include the error boundary, and a throw
        // inside componentDidCatch unmounts the whole React root.
    }
}
